import React from 'react';

import { PrimaryButton } from '@app/components/button';
import { ChevronRightIcon } from '@app/components/icons';
import { getParameterByName } from '@app/utility/getParameterByName';

import { CardTabOverlay } from '../card-tab-overlay-container';

export const PackageCardTabOverlay = ({
	auth = {},
	show = null,
	stepType = '',
	stepIndex = '',
	labels = {},
	hasCourseExams,
	hasMatchingCartItem = null,
	onClick,
	onLogin,
	onClose,
}) => {
	const [selectedPackageTitle, setSelectedPackageTitle] = React.useState(null);

	const { isAuthenticated } = auth;

	React.useEffect(() => {
		const prefix = stepType || 'package';
		const index = stepIndex ? `-${stepIndex}` : '';

		const title = labels && labels[`${prefix}-package${index}`];

		setSelectedPackageTitle(title);
	}, [labels, stepType, stepIndex]);

	const login = () => {
		if (onLogin) {
			onLogin('package');
		}

		let url = auth.loginUrl;

		const returnUrlParam = getParameterByName('returnUrl', auth.loginUrl);
		const cancelUrlParam = getParameterByName('cancelUrl', auth.loginUrl);

		url = url.replace(
			/returnUrl(=([^&#]*)|&|#|$)/,
			`returnUrl=${encodeURIComponent(
				`${returnUrlParam}?scroll-to-path=true`,
			)}`,
		);
		url = url.replace(
			/cancelUrl(=([^&#]*)|&|#|$)/,
			`cancelUrl=${encodeURIComponent(
				`${cancelUrlParam}?scroll-to-path=true`,
			)}`,
		);

		window.location.assign(url);
	};

	const resetPackageForm = () => onClose('package');

	return (
		<CardTabOverlay show={show} onClose={resetPackageForm}>
			<p className="u-font-family-primary course-panel__title course-panel__title--overlay">
				{selectedPackageTitle} <strong>has been added to your cart.</strong>
			</p>

			{hasMatchingCartItem || !hasCourseExams ? (
				<>
					<p>
						If you need to update this information, you can do so in the cart.
					</p>

					<a href="/cart" className="btn btn--primary" title="Cart">
						Continue to Cart
					</a>
				</>
			) : (
				<>
					{isAuthenticated ? (
						<>
							<p className="u-font-family-text course-overlay__help-text">
								You haven&apos;t selected your course exam yet.
								<strong>
									Register for your exam now - it&apos;s the best way to stay on
									track and succeed.
								</strong>
							</p>
							<PrimaryButton onClick={() => onClick(1)}>Buy Exam</PrimaryButton>
						</>
					) : (
						<>
							<p className="u-font-family-text course-overlay__help-text">
								You must be logged in to your account to select your course
								exam.
								<strong>
									Sign in or create an account to select your exam.
								</strong>
							</p>

							<PrimaryButton onClick={login}>Sign In</PrimaryButton>
						</>
					)}

					<div className="u-margin-top course-overlay__text-link">
						<a href="/cart" className="btn btn--icon btn--text" title="Cart">
							<span>
								Continue to Cart
								<ChevronRightIcon />
							</span>
						</a>
					</div>
				</>
			)}
		</CardTabOverlay>
	);
};
